import type { DeepValueOf } from '../interfaces/deep-value-of';
import { env } from './env-variables';

export type AppRoutesPaths = DeepValueOf<typeof APP_ROUTES>;

type StayRouteConfig = {
	path: AppRoutesPaths;
	whenAuthenticated: 'stay';
	redirectWhenAuthenticated?: never; // Não permitido
};

type RedirectRouteConfig = {
	path: AppRoutesPaths;
	whenAuthenticated: 'redirect';
	redirectWhenAuthenticated: string; // Obrigatório
};

export type PublicRoute = StayRouteConfig | RedirectRouteConfig;

export const APP_ROUTES = {
	PUBLIC: {
		LEARN_MORE: '/learn-more',
		MEDIA: `${env.NEXT_PUBLIC_API_SOURCE}/media/:media_id`,
		VERIFY_CREDENTIALS: '/verify-credentials',
		REGISTER: '/register',
		NOT_FOUND: '/not-found',
		LANDING_PAGE: '/',
		SHOWROOMS: '/showrooms',
		FAQ: '/faqs',
		LOGIN: '/login',
		PUBLIC_PROFILE: '/p/:profile_url',
	},
	PRIVATE: {
		HOME: '/home',
		PROFILE: '/profile',
		WELCOME: `/welcome`,
		INTRODUCTION: `/introduction`,
		RANKING: '/ranking',
		PROGRESS: '/progress',
		EXTRACT: '/extract',
		REWARDS: '/rewards',
		REWARD_ID: '/rewards/:reward_id',
		POSTS: '/posts',
		USERS: {
			USER_ID: '/users/:user_id',
		},
	},
	EXTERNAL: {
		ENTERPRISE: {
			BLOG: env.NEXT_PUBLIC_BLOG_URL,
			MAIN_WEB_SITE: env.NEXT_PUBLIC_MAIN_WEB_SITE_URL,
			INSTALLATION_MASTERS: env.NEXT_PUBLIC_INSTALLATION_MASTERS_URL,
			YOUTUBE: env.NEXT_PUBLIC_YOUTUBE_URL,
			INSTAGRAM: env.NEXT_PUBLIC_INSTAGRAM_URL,
			TIKTOK: env.NEXT_PUBLIC_TIKTOK_URL,
			PINTEREST: env.NEXT_PUBLIC_PINTEREST_URL,
			LINKEDIN: env.NEXT_PUBLIC_LINKEDIN_URL,
			WHO_WE_ARE: env.NEXT_PUBLIC_WHO_WE_ARE_URL,
			INSTAGRAM_POST_1: 'https://www.instagram.com/p/DFD8kRtvWoq/?img_index=1',
			INSTAGRAM_POST_2: 'https://www.instagram.com/p/DCAQLKgRh_T/?img_index=1',
			INSTAGRAM_POST_3: 'https://www.instagram.com/p/DIM0JZdpZ_j/?img_index=4',
			INSTAGRAM_POST_4: 'https://www.instagram.com/p/DEqJAzcxqk2/',
			BLOCKS_BY_GABSTER: env.NEXT_PUBLIC_BLOCKS_BY_GABSTER_URL,
		},
		SUPPORT: env.NEXT_PUBLIC_SUPPORT_URL,
	},
} as const;
